package pl.decks.personal.components.layouts.site

data class SiteLayoutData(
    val metaTitle: String,
    val metaDescription: String? = null,
    val isCopyright: Boolean = true,
)
